import axios from '../../axios'

/*
 * 海报模板数据接口
 */

// 获取海报模板列表
export const getPosterList = (data) => {
    return axios({
        url: '/api/base/poster',
        method: 'get',
        data
    })
}

// 获取海报模板列表
export const getPosterTemplate = (data) => {
    return axios({
        url: '/api/base/poster/list',
        method: 'get',
        data
    })
}

// 新增海报模板信息
export const savePoster = (data) => {
    return axios({
        url: '/api/base/poster',
        method: data.method || 'GET',
        data: data.data
    })
}

// 删除海报模板列表
export const deletePoster = (data) => {
    return axios({
        url: '/api/base/poster',
        method: 'delete',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/base/poster.js